<template>

    <div id="page-user-list">


        <vs-button size="large" @click="activePrompt" color="primary" class="mt-3 mb-8" type="filled">New Bank Account
        </vs-button>

        <vs-prompt title="Add Bank Account" accept-text="Add" @cancel="clearValMultiple" @accept="acceptAlert"
            @close="close" :is-valid="validName" :active.sync="activePromptStatus">
            <div class="con-exemple-prompt">
                <p class="mb-3">Choose your bank and enter your IBAN to <b>continue</b>.</p>

                <v-select data-vv-validate-on="blur" placeholder="Choose your bank" name="name"
                    v-model="selectedBank" v-validate="'required'" class="w-full mb-2" label="name"
                    :options="bankNames" @input="setSwift" />



<label class="mt-4 vs-input--label"> Currency</label>
                    <v-select data-vv-validate-on="blur" placeholder="Choose your currency" name="currency"
                    v-model="selectedCurrency" v-validate="'required'" class="w-full  mb-2" label="code"
                    :options="currencyOptions" />



               
                <vs-input placeholder="Account Owner" label="Owner" v-model="bank.accountOwner" class="mt-4 mb-2 w-full" />
                <vs-input placeholder="IBAN Number" label="IBAN" v-model="bank.iban" class="mt-4 mb-2 w-full" />
                <vs-input disabled placeholder="Swift Code" label="Swift" v-model="bank.swift" class="mt-4 mb-2 w-full" />
                <label class="vs-input--label"> Account type</label>
                <v-select data-vv-validate-on="blur" placeholder="Select type of account" name="platform_name"
                    v-model="bank.type" v-validate="'required'" class="w-full" label="typeName"
                    :options="paymentTypeOptions"  />


                <vs-input placeholder="Client ID" label="Client ID" v-if="bank.type && bank.type.typeCode == 1" v-model="bank.shopCode" class="mt-4 mb-2 w-full" />
                <vs-input placeholder="Store Key" label="Store Key" v-if="bank.type && bank.type.typeCode == 1" v-model="bank.storeKey"  class="mt-4 mb-2 w-full" />



            </div>
        </vs-prompt>





        <div class="vx-card p-6">
            <div class="flex flex-wrap items-center">

                <!-- ITEMS PER PAGE -->
                <div class="flex-grow">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} -
                                {{ bankAccounts.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : bankAccounts.length }}
                                of {{ bankAccounts.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                                <span>25</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

            </div>


            <!-- AgGrid Table -->
            <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" style="width: 100%;"
                :defaultColDef="defaultColDef" :rowData="bankAccounts" colResizeDefault="shift" :animateRows="true"
                :floatingFilter="false" :pagination="true" :paginationPageSize="paginationPageSize"
                :suppressPaginationPanel="true" :enableRtl="$vs.rtl">
            </ag-grid-vue>

            <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />

        </div>
    </div>

</template>

<script>
    import {
        AgGridVue
    } from 'ag-grid-vue'
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

    // Store Module

    // Cell Renderer
    import CellRendererVerified from './cell-renderer/CellRendererVerified'
    import CellRendererActions from './cell-renderer/CellRendererActions'
    import CellRendererBank from './cell-renderer/CellRendererBank'
    import vSelect from 'vue-select'


    export default {
        components: {
            AgGridVue,
            CellRendererVerified,
            CellRendererActions,
            CellRendererBank,
            'v-select': vSelect,
        },
        created() {
            this.getCurrencies()
            
        },
        data() {
            return {

                currencyOptions:[],
                activePromptStatus: false,
                val: '',
                paymentTypeOptions: [{
                        typeName: 'Credit card',
                        typeCode: '1'
                    },
                    {
                        typeName: 'Bank trnsfer',
                        typeCode: '2'
                    }
                ],
                bankNames:[
                    {
                        name:'',
                        imageUrl:'',
                        swiftCode:''
                    }
                ],
                selectedBank:'',
                selectedCurrency:'',
                bank: {
                    name: '',
                    iban: '',
                    swift: '',
                    type: {typeCode:null},
                    shopCode: null,
                    storeKey: null,
                    accountOwner:''
                },

                isVerifiedFilter: {
                    label: 'All',
                    value: 'all'
                },
                isVerifiedOptions: [{
                        label: 'All',
                        value: 'all'
                    },
                    {
                        label: 'Yes',
                        value: 'yes'
                    },
                    {
                        label: 'No',
                        value: 'no'
                    }
                ],
                searchQuery: '',

                // AgGrid
                gridApi: null,
                gridOptions: {},
                defaultColDef: {
                    sortable: true,
                    resizable: true,
                    suppressMenu: true
                },
                columnDefs: [

                    {
                        headerName: 'ID',
                        field: 'id',
                        filter: true,
                        width: 80,
                    },
                    {
                        headerName: 'Bank Name',
                        field: 'bank.name',
                        filter: true,
                        width: 170,
                        cellRendererFramework: 'CellRendererBank',
                    },
                    {
                        headerName: 'IBAN',
                        field: 'ibanNo',
                        filter: true,
                        width: 220
                    },
                    {
                        headerName: 'Swift',
                        field: 'bank.swiftCode',
                        filter: true,
                        width: 190
                    },

                    {
                        headerName: 'Currency',
                        field: 'currency',
                        filter: true,
                        width: 100
                    },

                    {
                        headerName: 'Status',
                        field: 'isActive',
                        filter: true,
                        cellRendererFramework: 'CellRendererVerified',
                        cellClass: 'grid-cell-centered',
                        width: 100
                    },

                    {
                        headerName: 'Actions',
                        field: 'transactions',
                        filter: true,
                        cellRendererFramework: 'CellRendererActions',
                        cellClass: 'grid-cell-centered',
                        width: 120
                    },


                ],

                // Cell Renderer Components
                components: {
                    CellRendererVerified,
                    CellRendererActions,
                    CellRendererBank
                }
            }
        },

        computed: {

            validName() {
                return ( this.bank.iban.length > 0 && this.bank.swift.length > 0 && this
                    .bank.type != null)
            },

            bankAccounts() {
                return this.$store.getters['bank/allAccounts']
            },

            paginationPageSize() {
                if (this.gridApi) return this.gridApi.paginationGetPageSize()
                else return 20
            },
            totalPages() {
                if (this.gridApi) return this.gridApi.paginationGetTotalPages()
                else return 0
            },
            currentPage: {
                get() {
                    if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1)
                }
            }
        },
        methods: {
            getCurrencies(){
                 this.$store.dispatch('product/getCurrencies')
                 .then((response) => {
                       this.currencyOptions = response.data
                       this.getAllAccounts()
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
            },
            setSwift(){
                this.selectedBank != null && this.selectedBank.swiftCode ? this.bank.swift =  this.selectedBank.swiftCode : this.bank.swift = ''
               
            },
            activePrompt() {
                this.activePromptStatus = true
                this.$vs.loading();
                this.$store.dispatch('bank/getBanks')
                    .then((response) => {
                        this.$vs.loading.close()
                        this.bankNames = response.data
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })

            },

            acceptAlert() {
                this.$vs.loading()
                const payload = {}
                payload["currencyId"] = this.selectedCurrency.id
                payload["accountOwner"] = this.bank.accountOwner
                payload["SwiftCode"] = this.bank.swift
                payload["ibanNo"] = this.bank.iban
                payload["BankId"] = this.selectedBank.id
                payload["AccountType"] = this.bank.type.typeCode
                payload["shopCode"] = this.bank.shopCode
                payload["storeKey"] = this.bank.storeKey
                this.$store.dispatch('bank/createAccount', payload)
                    .then((response) => {
                        this.$vs.loading.close()
                        this.getAllAccounts();
                        this.$vs.notify({
                            color: 'success',
                            title: 'Acccount added',
                            text: response.data.message
                        })
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })


            },
            close() {
                 this.bank.iban = "";
                this.selectedBank = null
                this.bank.type = null
                return true
            },
            clearValMultiple() {
               
                this.bank.iban = "";
                this.selectedBank = null
                this.bank.type = null
               
            },


            getAllAccounts() {
                this.$store.dispatch('bank/getAllAccounts')
                    .then((response) => {
                        return true
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
            },
            setColumnFilter(column, val) {
                const filter = this.gridApi.getFilterInstance(column)
                let modelObj = null

                if (val !== 'all') {
                    modelObj = {
                        type: 'equals',
                        filter: val
                    }
                }

                filter.setModel(modelObj)
                this.gridApi.onFilterChanged()
            },

            resetColFilters() {
                // Reset Grid Filter
                this.gridApi.setFilterModel(null)
                this.gridApi.onFilterChanged()

                // Reset Filter Options
                this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
                    label: 'All',
                    value: 'all'
                }

                this.$refs.filterCard.removeRefreshAnimation()
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api

            /* =================================================================
              NOTE:
              Header is not aligned properly in RTL version of agGrid table.
              However, we given fix to this issue. If you want more robust solution please contact them at gitHub
            ================================================================= */
            if (this.$vs.rtl) {
                const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
                header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
            }
        },

    }
</script>

<style lang="scss">
    #page-user-list {
        .user-list-filters {
            .vs__actions {
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-58%);
            }
        }
    }
</style>